<template lang="html">




  <div class="wrapper -orientacion error">

<div class="encabezado">

  <div class="container column-start">
    <div class="contenedor-logo">
      <router-link to="/">
        <img src="/static/img/UFV-logo.png" alt="Logo UFV">
      </router-link>
    </div>
  </div>

</div>
<section class="mensaje-error">
<h1>404</h1>
<p>Página no encontrada</p>
  

</section>

  



</div>
</template>


<script lang="js">

export default {
  name: 'error-404',
}
</script>




// WEBPACK FOOTER //
// src/components/views/error-404.vue